// Teclado na tela de pagamento do BALCÃO (pedido do dono, 29/09/2026): Tab
// (ou as setas) alterna a forma de pagamento acesa (Shift+Tab / ← ↑ voltam), Enter escolhe a acesa
// (Dinheiro abre o "Valor recebido") e, com a forma já definida, Enter
// finaliza o pedido. Esc volta para "Como deseja consumir?". No Dividir, Enter
// finaliza quando as partes fecham o total. O Totem não tem teclado.
import { useEffect, useState } from "react";

import { ID_BUSCA_CLIENTE } from "../components/BuscaClienteBalcao";
import { useAtalhosBalcao } from "./useAtalhosBalcao";

export function useTeclasPagamento(c) {
  const { autoAtendimento, payments, paymentMethod, handleSelectPayment, canSubmitNormal, canSubmitSplit, splitPayment, showSplitModal, submitOrder, setScreen } = c;
  const teclado = !autoAtendimento;
  const [aceso, setAceso] = useState(0);
  // A forma escolhida (clique ou Enter) passa a ser a acesa.
  useEffect(() => {
    const i = payments.findIndex((p) => p.id === paymentMethod);
    if (i >= 0) setAceso(i);
  }, [paymentMethod, payments]);
  const idx = Math.min(aceso, Math.max(payments.length - 1, 0));
  const andar = (passo) => {
    if (splitPayment || showSplitModal || payments.length === 0) return false;
    setAceso((idx + passo + payments.length) % payments.length);
    return true;
  };
  useAtalhosBalcao({
    Tab: (e) => andar(e.shiftKey ? -1 : 1),
    // Setas = Tab (pedido do dono): → e ↓ vão para a próxima, ← e ↑ voltam.
    ArrowRight: () => andar(1),
    ArrowDown: () => andar(1),
    ArrowLeft: () => andar(-1),
    ArrowUp: () => andar(-1),
    Enter: () => {
      if (showSplitModal) return false;
      if (splitPayment) {
        if (!canSubmitSplit) return false;
        submitOrder();
        return true;
      }
      const alvo = payments[idx];
      if (!alvo) return false;
      if (paymentMethod === alvo.id && canSubmitNormal) submitOrder();
      else handleSelectPayment(alvo.id);
      return true;
    },
    Escape: () => {
      if (showSplitModal) return false;
      setScreen("delivery_type");
      return true;
    },
    // F2 = busca de cliente (pedido do dono, 29/09/2026).
    F2: () => { const campo = document.getElementById(ID_BUSCA_CLIENTE); if (!campo) return false; campo.focus(); return true; },
  }, teclado);
  return teclado && !splitPayment ? idx : null;
}
